
// import React from 'react';
// import bikeImage1 from '../assets/Scooter.png';
// import bikeImage2 from '../assets/Electrical.png';
// import bikeImage3 from '../assets/Rx.png';
// import bikeImage4 from '../assets/SportsBike.png';

// const locations = ["Bangalore", "Delhi", "Mumbai", "Chennai", "Hyderabad"];
// const images = [bikeImage1, bikeImage2, bikeImage3, bikeImage4];

// function DailyRental() {
//     return (
//         <div className="flex min-h-screen ">

//             <div className="w-full">

//                 <div className="flex justify-end mb-6">
//                     <h2 className="text-lg font-semibold">Sort by:</h2>
//                     <div className="flex space-x-4 ml-4">
//                         <button className="text-blue-600">Relevance</button>
//                         <button className="text-blue-600">Price - Low to High</button>
//                         <button className="text-blue-600">Price - High to Low</button>
//                     </div>
//                 </div>

//                 {/* Grid layout */}
//                 <div className="grid grid-cols-3 gap-6">
//                     {/* Render 8 blocks in 2/2 grid (2 blocks per row) */}
//                     {[...Array(8)].map((_, index) => (
//                         <div key={index} className="relative border rounded-lg shadow-lg p-6 flex flex-col justify-between">
//                             {/* New label at the top left corner */}
//                             <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
//                                 New
//                             </span>

//                             {/* Display different images */}
//                             <img
//                                 src={images[index % images.length]}
//                                 alt="Hero Glamour Xtec"
//                                 className="w-full mt-4 h-auto border"
//                             />
//                             <div className="mt-4">
//                                 <h2 className="text-xl font-semibold">Hero Glamour Xtec 125 cc</h2>
//                                 <p className="text-gray-600 text-left mt-4">1288 km included</p>
//                                 <p className="text-sm text-left">(Excess ₹ 3/km + GST)</p> <br />
//                             </div>

//                             {/* Location bar */}
//                             <div className="bg-white p-1 border shadow-md rounded flex items-center space-x-2 h-[3rem] mb-4">
//                                 <p className="font-semibold text-sm whitespace-nowrap">Location:</p>
//                                 <select className="flex-1 border rounded px-2 py-1 h-full text-sm">
//                                     {locations.map((location, i) => (
//                                         <option key={i} value={location}>
//                                             {location}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>

//                             {/* Price and Book button */}
//                             <div className="flex justify-between items-center mt-0">
//                                 <span className="text-gray-700 font-semibold">Pay: ₹11753/Month</span>
//                                 <button className="bg-[#FF9630] text-white px-4 py-2 rounded">
//                                     Book Now
//                                 </button>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default DailyRental;


// import React from 'react';
// import { MdLocationOn } from 'react-icons/md'; // Importing the map icon
// import { useNavigate } from 'react-router-dom'; // Import useNavigate

// const locations = ["Bangalore", "Delhi", "Mumbai", "Chennai", "Hyderabad"];
// const bikeData =
//     [
//         {
//             "id": 1,
//             "title": "Hero Glamour Xtec 125 cc",
//             "image": "Scooter.png",
//             "description": "1288 km included",
//             "excess": "₹ 3/km + GST",
//             "location": "Bangalore",
//             "price": "₹11753/Month"
//         },
//         {
//             "id": 2,
//             "title": "Hero Glamour Xtec 125 cc",
//             "image": "Electrical.png",
//             "description": "1500 km included",
//             "excess": "₹ 5/km + GST",
//             "location": "Delhi",
//             "price": "₹12000/Month"
//         },
//         {
//             "id": 3,
//             "title": "RX 100 120cc",
//             "image": "Rx.png",
//             "description": "1000 km included",
//             "excess": "₹ 4/km + GST",
//             "location": "Mumbai",
//             "price": "₹9000/Month"
//         },
//         {
//             "id": 4,
//             "title": "Sports Bike 150 cc",
//             "image": "SportsBike.png",
//             "description": "2000 km included",
//             "excess": "₹ 6/km + GST",
//             "location": "Chennai",
//             "price": "₹15000/Month"
//         },
//         {
//             "id": 5,
//             "title": "Hero Glamour Xtec 125 cc",
//             "image": "Scooter.png",
//             "description": "1200 km included",
//             "excess": "₹ 3/km + GST",
//             "location": "Hyderabad",
//             "price": "₹11000/Month"
//         },
//         {
//             "id": 6,
//             "title": "Hero Glamour Xtec 125 cc",
//             "image": "Electrical.png",
//             "description": "1500 km included",
//             "excess": "₹ 4/km + GST",
//             "location": "Bangalore",
//             "price": "₹11500/Month"
//         },
//         {
//             "id": 7,
//             "title": "RX 100 120cc",
//             "image": "Rx.png",
//             "description": "900 km included",
//             "excess": "₹ 5/km + GST",
//             "location": "Delhi",
//             "price": "₹9500/Month"
//         },
//         {
//             "id": 8,
//             "title": "Sports Bike 150 cc",
//             "image": "SportsBike.png",
//             "description": "1800 km included",
//             "excess": "₹ 7/km + GST",
//             "location": "Mumbai",
//             "price": "₹16000/Month"
//         },
//         {
//             "id": 9,
//             "title": "Sports Bike 150 cc",
//             "image": "SportsBike.png",
//             "description": "1800 km included",
//             "excess": "₹ 7/km + GST",
//             "location": "Mumbai",
//             "price": "₹16000/Month"
//         }
//     ]


// function DailyRental() {
//     const navigate = useNavigate(); // Initialize the useNavigate hook

//     // Function to handle Book Now button click
//     const handleBookNow = (bikeId) => {
//         navigate(`/accesories-component`); // Redirect to the booking page with bikeId
//     };

//     return (
//         <div className="flex min-h-screen">
//             <div className="w-full">

//                 <div className="flex mb-6">
//                     <h2 className="text-lg font-semibold">Sort by:</h2>
//                     <div className="flex space-x-4 ml-4">
//                         <button className="text-gray-400 ">Relevance</button>
//                         <button className="text-gray-400">Price - Low to High</button>
//                         <button className="text-gray-400">Price - High to Low</button>
//                     </div>
//                 </div>

//                 {/* Grid layout */}
//                 <div className="grid grid-cols-3 gap-6">
//                     {/* Render 8 blocks from the JSON data */}
//                     {bikeData.map((bike, index) => (
//                         <div key={bike.id} className="relative border rounded-md shadow-lg  flex flex-col justify-between">
//                             {/* New label at the top left corner */}
//                             <div className='p-6 '>
//                             <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
//                                 New
//                             </span>

//                             {/* Display different images */}
//                             <img
//                                 src={require(`../assets/${bike.image}`)} // Dynamically loading image
//                                 alt={bike.title}
//                                 className="w-full mt-4 h-auto border rounded-md"
//                             />


//                             <div className="mt-4">
//                                 <h2 className="text-lg text-center font-semibold">{bike.title}</h2>
//                                 {/* Line with the map icon */}
//                                 <div className="flex items-center text-gray-600 mt-4">
//                                     <MdLocationOn className="text-xl mr-1 text-red-500" /> {/* Map icon */}
//                                     <p className="text-gray-600 text-left ">{bike.description}</p>
//                                 </div>
//                                 <p className="text-sm text-left pl-6 ">{bike.excess} </p>
//                             </div>

//                             {/* Location bar */}
//                           </div>
//                             <div className='border-t px-4'>
//                             <div className="bg-white p-1 border  rounded flex items-center space-x-2 h-auto mb-4 mt-3 ">
//                                 <p className="font-semibold text-sm whitespace-nowrap">Location:</p>
//                                 <select className="flex-1 rounded px-2 py-1 h-full text-sm">
//                                     {locations.map((location, i) => (
//                                         <option key={i} value={location}>
//                                             {location}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>
//                             </div>

//                             {/* Price and Book button */}
//                             <div className="flex justify-between items-center  p-3">
//                                 <span className="text-gray-700 font-semibold">Pay: {bike.price}</span>
//                                 <button
//                                     className="bg-[#FF9630] text-white px-4 py-2 rounded"
//                                     onClick={() => handleBookNow(bike.id)} // Call the navigation function
//                                 >
//                                     Book Now
//                                 </button>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default DailyRental;


// import React, { useState } from 'react';
// import { MdLocationOn } from 'react-icons/md'; // Importing the map icon
// import { useNavigate } from 'react-router-dom'; // Import useNavigate

// const locations = ["Bangalore", "Delhi", "Mumbai", "Chennai", "Hyderabad"];
// const bikeData = [
//   {
//     "id": 1,
//     "title": "Hero Glamour Xtec 125 cc",
//     "image": "Scooter.png",
//     "description": "1288 km included",
//     "excess": "₹ 3/km + GST",
//     "location": "Bangalore",
//     "price": "₹11753/Month"
//   },
//   {
//     "id": 2,
//     "title": "Hero Glamour Xtec 125 cc",
//     "image": "Electrical.png",
//     "description": "1500 km included",
//     "excess": "₹ 5/km + GST",
//     "location": "Delhi",
//     "price": "₹12000/Month"
//   },
//   {
//     "id": 3,
//     "title": "Hero Glamour Xtec 125 cc",
//     "image": "Scooter.png",
//     "description": "1288 km included",
//     "excess": "₹ 3/km + GST",
//     "location": "Bangalore",
//     "price": "₹11753/Month"
//   },
//   {
//     "id": 4,
//     "title": "Hero Glamour Xtec 125 cc",
//     "image": "Scooter.png",
//     "description": "1288 km included",
//     "excess": "₹ 3/km + GST",
//     "location": "Bangalore",
//     "price": "₹11753/Month"
//   },
//   {
//     "id": 3,
//     "title": "Hero Glamour Xtec 125 cc",
//     "image": "Scooter.png",
//     "description": "1288 km included",
//     "excess": "₹ 3/km + GST",
//     "location": "Bangalore",
//     "price": "₹11753/Month"
//   },
//   {
//     "id": 4,
//     "title": "Hero Glamour Xtec 125 cc",
//     "image": "Scooter.png",
//     "description": "1288 km included",
//     "excess": "₹ 3/km + GST",
//     "location": "Bangalore",
//     "price": "₹11753/Month"
//   },
//   {
//     "id": 3,
//     "title": "Hero Glamour Xtec 125 cc",
//     "image": "Scooter.png",
//     "description": "1288 km included",
//     "excess": "₹ 3/km + GST",
//     "location": "Bangalore",
//     "price": "₹11753/Month"
//   },
//   {
//     "id": 4,
//     "title": "Hero Glamour Xtec 125 cc",
//     "image": "Scooter.png",
//     "description": "1288 km included",
//     "excess": "₹ 3/km + GST",
//     "location": "Bangalore",
//     "price": "₹11753/Month"
//   },
//   {
//     "id": 3,
//     "title": "Hero Glamour Xtec 125 cc",
//     "image": "Scooter.png",
//     "description": "1288 km included",
//     "excess": "₹ 3/km + GST",
//     "location": "Bangalore",
//     "price": "₹11753/Month"
//   },
//   {
//     "id": 4,
//     "title": "Hero Glamour Xtec 125 cc",
//     "image": "Scooter.png",
//     "description": "1288 km included",
//     "excess": "₹ 3/km + GST",
//     "location": "Bangalore",
//     "price": "₹11753/Month"
//   },
//   {
//     "id": 3,
//     "title": "Hero Glamour Xtec 125 cc",
//     "image": "Scooter.png",
//     "description": "1288 km included",
//     "excess": "₹ 3/km + GST",
//     "location": "Bangalore",
//     "price": "₹11753/Month"
//   },
//   {
//     "id": 4,
//     "title": "Hero Glamour Xtec 125 cc",
//     "image": "Scooter.png",
//     "description": "1288 km included",
//     "excess": "₹ 3/km + GST",
//     "location": "Bangalore",
//     "price": "₹11753/Month"
//   },
//   {
//     "id": 3,
//     "title": "Hero Glamour Xtec 125 cc",
//     "image": "Scooter.png",
//     "description": "1288 km included",
//     "excess": "₹ 3/km + GST",
//     "location": "Bangalore",
//     "price": "₹11753/Month"
//   },
//   {
//     "id": 4,
//     "title": "Hero Glamour Xtec 125 cc",
//     "image": "Scooter.png",
//     "description": "1288 km included",
//     "excess": "₹ 3/km + GST",
//     "location": "Bangalore",
//     "price": "₹11753/Month"
//   },
//   // ... other bike data
// ];

// function DailyRental() {
//   const navigate = useNavigate(); // Initialize the useNavigate hook
//   const [formData, setFormData] = useState(null); // State to store FormData

//   // Function to handle Book Now button click and form submission
//   const handleBookNow = (bike) => {
//     const data = new FormData();
//     data.append('id', bike.id);
//     data.append('title', bike.title);
//     data.append('description', bike.description);
//     data.append('price', bike.price);
//     data.append('location', bike.location);

//     // Optionally add the image name or path
//     data.append('image', bike.image);

//     // Set form data to state (optional for later use, e.g., sending to backend)
//     setFormData(data);

//     // Optionally log or send the FormData
//     console.log('Form Data Submitted:', Object.fromEntries(data.entries()));

//     // Navigate to another page after submitting form data
//     navigate(`/accesories-component`);
//   };

//   return (
//     <div className="flex min-h-screen">
//       <div className="w-full">
//         <div className="flex mb-6">
//           <h2 className="text-lg font-semibold">Sort by:</h2>
//           <div className="flex space-x-4 ml-4">
//             <button className="text-gray-400 ">Relevance</button>
//             <button className="text-gray-400">Price - Low to High</button>
//             <button className="text-gray-400">Price - High to Low</button>
//           </div>
//         </div>

//         {/* Grid layout */}
//         <div className="grid grid-cols-3 gap-6">
//           {/* Render bike data */}
//           {bikeData.map((bike) => (
//             <div key={bike.id} className="relative border rounded-md shadow-lg flex flex-col justify-between">
//               {/* New label at the top left corner */}
//               <div className='p-6'>
//                 <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
//                   New
//                 </span>

//                 {/* Display image */}
//                 <img
//                   src={require(`../assets/${bike.image}`)} // Dynamically loading image
//                   alt={bike.title}
//                   className="w-full mt-4 h-auto border rounded-md"
//                 />

//                 <div className="mt-4">
//                   <h2 className="text-lg text-center font-semibold">{bike.title}</h2>
//                   {/* Line with the map icon */}
//                   <div className="flex items-center text-gray-600 mt-4">
//                     <MdLocationOn className="text-xl mr-1 text-red-500" /> {/* Map icon */}
//                     <p className="text-gray-600 text-left">{bike.description}</p>
//                   </div>
//                   <p className="text-sm text-left pl-6">{bike.excess}</p>
//                 </div>

//                 {/* Location selection */}
//               </div>

//               <div className='border-t px-4'>
//                 <div className="bg-white p-1 border rounded flex items-center space-x-2 h-auto mb-4 mt-3">
//                   <p className="font-semibold text-sm whitespace-nowrap">Location:</p>
//                   <select className="flex-1 rounded px-2 py-1 h-full text-sm">
//                     {locations.map((location, i) => (
//                       <option key={i} value={location}>
//                         {location}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>

//               {/* Price and Book button */}
//               <div className="flex justify-between items-center p-3">
//                 <span className="text-gray-700 font-semibold">Pay: {bike.price}</span>
//                 <button
//                   className="bg-[#FF9630] text-white px-4 py-2 rounded"
//                   onClick={() => handleBookNow(bike)} // Call the form submission function
//                 >
//                   Book Now
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Optionally display form data */}
//       {formData && (
//         <div className="mt-4 p-4 border border-gray-300 rounded-md">
//           <h3 className="text-xl font-semibold">Submitted Form Data:</h3>
//           <pre>{JSON.stringify(Object.fromEntries(formData.entries()), null, 2)}</pre>
//         </div>
//       )}
//     </div>
//   );
// }

// export default DailyRental;



// import React, { useState } from 'react';
// import { MdLocationOn } from 'react-icons/md';
// import { useNavigate } from 'react-router-dom';

// const locations = ["Bangalore", "Delhi", "Mumbai", "Chennai", "Hyderabad"];
// const bikeData = [
//   {
//     id: 1,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Scooter.png",
//     description: "1288 km included",
//     excess: "₹ 3/km + GST",
//     location: "Bangalore",
//     price: 11753,
//   },
//   {
//     id: 2,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 12000,
//   },
//   {
//     id: 3,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "SportsBike.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 100,
//   },
//   {
//     id: 4,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 1000,
//   },
//   {
//     id: 5,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 120080,
//   },
//   {
//     id: 6,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "SportsBike.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 18000,
//   },
//   {
//     id: 7,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 17000,
//   },
//   {
//     id: 8,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "SportsBike.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 19000,
//   },
//   {
//     id: 9,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 18000,
//   },
//   {
//     id: 10,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 17700,
//   },


//   // Add more bikes here
// ];

// function DailyRental() {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState(null);
//   const [filteredBikes, setFilteredBikes] = useState(bikeData); // State to hold filtered data

//   // Function to handle filter logic
//   const handleFilter = (filterType) => {
//     let sortedBikes = [...bikeData];

//     switch (filterType) {
//       case "priceLowToHigh":
//         sortedBikes.sort((a, b) => a.price - b.price);
//         break;
//       case "priceHighToLow":
//         sortedBikes.sort((a, b) => b.price - a.price);
//         break;
//       default:
//         sortedBikes = bikeData; // Default to relevance (original order)
//     }

//     setFilteredBikes(sortedBikes);
//   };

//   const handleBookNow = (bike) => {
//     const data = new FormData();
//     data.append("id", bike.id);
//     data.append("title", bike.title);
//     data.append("description", bike.description);
//     data.append("price", bike.price);
//     data.append("location", bike.location);
//     data.append("image", bike.image);

//     setFormData(data);

//     console.log("Form Data Submitted:", Object.fromEntries(data.entries()));

//     navigate(`/accesories-component`);
//   };

//   return (
//     <div className="flex min-h-screen">
//       <div className="w-full">
//         <div className="flex mb-6">
//           <h2 className="text-lg font-semibold">Sort by:</h2>
//           <div className="flex space-x-4 ml-4">
//             <button
//               className="text-gray-400 hover:text-[#FF9630]"
//               onClick={() => handleFilter("relevance")}
//             >
//               Relevance
//             </button>
//             <button
//               className="text-gray-400 hover:text-[#FF9630]"
//               onClick={() => handleFilter("priceLowToHigh")}
//             >
//               Price - Low to High
//             </button>
//             <button
//               className="text-gray-400 hover:text-[#FF9630]"
//               onClick={() => handleFilter("priceHighToLow")}
//             >
//               Price - High to Low
//             </button>
//           </div>
//         </div>

//         <div className="grid grid-cols-3 gap-6">
//           {filteredBikes.map((bike) => (
//             <div
//               key={bike.id}
//               className="relative border rounded-md shadow-lg flex flex-col justify-between"
//             >
//               <div className="p-6">
//                 <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
//                   New
//                 </span>
//                 <img
//                   src={require(`../assets/${bike.image}`)}
//                   alt={bike.title}
//                   className="w-full mt-4 h-auto border rounded-md"
//                 />
//                 <div className="mt-4">
//                   <h2 className="text-lg text-center font-semibold">
//                     {bike.title}
//                   </h2>
//                   <div className="flex items-center text-gray-600 mt-4">
//                     <MdLocationOn className="text-xl mr-1 text-red-500" />
//                     <p className="text-gray-600 text-left">{bike.description}</p>
//                   </div>
//                   <p className="text-sm text-left pl-6">{bike.excess}</p>
//                 </div>
//               </div>
//               <div className="border-t px-4">
//                 <div className="bg-white p-1 border rounded flex items-center space-x-2 h-auto mb-4 mt-3">
//                   <p className="font-semibold text-sm whitespace-nowrap">
//                     Location:
//                   </p>
//                   <select className="flex-1 rounded px-2 py-1 h-full text-sm">
//                     {locations.map((location, i) => (
//                       <option key={i} value={location}>
//                         {location}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <div className="flex justify-between items-center p-3">
//                 <span className="text-gray-700 font-semibold">
//                   Pay: ₹{bike.price}/Month
//                 </span>
//                 <button
//                   className="bg-[#FF9630] text-white px-4 py-2 rounded"
//                   onClick={() => handleBookNow(bike)}
//                 >
//                   Book Now
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {formData && (
//         <div className="mt-4 p-4 border border-gray-300 rounded-md">
//           <h3 className="text-xl font-semibold">Submitted Form Data:</h3>
//           <pre>{JSON.stringify(Object.fromEntries(formData.entries()), null, 2)}</pre>
//         </div>
//       )}
//     </div>
//   );
// }

// export default DailyRental;



// import React, { useState } from 'react';
// import { MdLocationOn } from 'react-icons/md';
// import { useNavigate } from 'react-router-dom';

// const locations = ["Bangalore", "Delhi", "Mumbai", "Chennai", "Hyderabad"];
// const bikeData = [
//   {
//     id: 1,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Scooter.png",
//     description: "1288 km included",
//     excess: "₹ 3/km + GST",
//     location: "Bangalore",
//     price: 11753,
//   },
//   {
//     id: 2,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 12000,
//   },
//   {
//     id: 3,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "SportsBike.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 100,
//   },
//   {
//     id: 4,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 1000,
//   },
//   {
//     id: 5,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 120080,
//   },
//   {
//     id: 6,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "SportsBike.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 18000,
//   },
//   {
//     id: 7,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 17000,
//   },
//   {
//     id: 8,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "SportsBike.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 19000,
//   },
//   {
//     id: 9,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 18000,
//   },
//   {
//     id: 10,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 17700,
//   },
//   // Add more bikes here
// ];

// function DailyRental() {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState(null);
//   const [filteredBikes, setFilteredBikes] = useState(bikeData); // State to hold filtered data

//   // Function to handle filter logic
//   const handleFilter = (filterType) => {
//     let sortedBikes = [...bikeData];

//     switch (filterType) {
//       case "priceLowToHigh":
//         sortedBikes.sort((a, b) => a.price - b.price);
//         break;
//       case "priceHighToLow":
//         sortedBikes.sort((a, b) => b.price - a.price);
//         break;
//       default:
//         sortedBikes = bikeData; // Default to relevance (original order)
//     }

//     setFilteredBikes(sortedBikes);
//   };

//   const handleBookNow = (bike) => {
//     const data = new FormData();
//     data.append("id", bike.id);
//     data.append("title", bike.title);
//     data.append("description", bike.description);
//     data.append("price", bike.price);
//     data.append("location", bike.location);
//     data.append("image", bike.image);

//     setFormData(data);

//     console.log("Form Data Submitted:", Object.fromEntries(data.entries()));

//     navigate(`/accesories-component`);

//     if (window.innerWidth <= 768) {
//       navigate('/accesories');
//     } else {
//       navigate('/accesories-component');
//     }

//   };

//   return (
//     <div className="flex min-h-screen p-5">
//       <div className="w-full">
//         <div className="flex mb-6">
//           <h2 className="text-lg font-semibold">Sort by:</h2>
//           <div className="flex space-x-4 ml-4">
//             <button
//               className="text-gray-400 hover:text-[#FF9630]"
//               onClick={() => handleFilter("relevance")}
//             >
//               Relevance
//             </button>
//             <button
//               className="text-gray-400 hover:text-[#FF9630]"
//               onClick={() => handleFilter("priceLowToHigh")}
//             >
//               Price - Low to High
//             </button>
//             <button
//               className="text-gray-400 hover:text-[#FF9630]"
//               onClick={() => handleFilter("priceHighToLow")}
//             >
//               Price - High to Low
//             </button>
//           </div>
//         </div>

//         {/* Responsive Grid: 1 item per row on mobile, 3 items on larger screens */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//           {filteredBikes.map((bike) => (
//             <div
//               key={bike.id}
//               className="relative border rounded-md shadow-lg flex flex-col justify-between"
//             >
//               <div className="p-6">
//                 <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
//                   New
//                 </span>
//                 <img
//                   src={require(`../assets/${bike.image}`)}
//                   alt={bike.title}
//                   className="w-full mt-4 h-auto border rounded-md"
//                 />
//                 <div className="mt-4">
//                   <h2 className="text-lg text-center font-semibold">
//                     {bike.title}
//                   </h2>
//                   <div className="flex items-center text-gray-600 mt-4">
//                     <MdLocationOn className="text-xl mr-1 text-red-500" />
//                     <p className="text-gray-600 text-left">{bike.description}</p>
//                   </div>
//                   <p className="text-sm text-left pl-6">{bike.excess}</p>
//                 </div>
//               </div>
//               <div className="border-t px-4">
//                 <div className="bg-white p-1 border rounded flex items-center space-x-2 h-auto mb-4 mt-3">
//                   <p className="font-semibold text-sm whitespace-nowrap">
//                     Location:
//                   </p>
//                   <select className="flex-1 rounded px-2 py-1 h-full text-sm">
//                     {locations.map((location, i) => (
//                       <option key={i} value={location}>
//                         {location}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <div className="flex justify-between items-center p-3">
//                 <span className="text-gray-700 font-semibold">
//                   Pay: ₹{bike.price}/Month
//                 </span>
//                 <button
//                   className="bg-[#FF9630] text-white px-4 py-2 rounded"
//                   onClick={() => handleBookNow(bike)}
//                 >
//                   Book Now
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {formData && (
//         <div className="mt-4 p-4 border border-gray-300 rounded-md">
//           <h3 className="text-xl font-semibold">Submitted Form Data:</h3>
//           <pre>{JSON.stringify(Object.fromEntries(formData.entries()), null, 2)}</pre>
//         </div>
//       )}
//     </div>
//   );
// }

// export default DailyRental;

// import React, { useState } from 'react';
// import { MdLocationOn } from 'react-icons/md';
// import { useNavigate } from 'react-router-dom';

// const locations = ["Bangalore", "Delhi", "Mumbai", "Chennai", "Hyderabad"];
// const bikeData = [
//   {
//     id: 1,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Scooter.png",
//     description: "1288 km included",
//     excess: "₹ 3/km + GST",
//     location: "Bangalore",
//     price: 11753,
//   },
//   {
//     id: 2,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 12000,
//   },
//   {
//     id: 3,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "SportsBike.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 100,
//   },
//   {
//     id: 4,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 1000,
//   },
//   {
//     id: 5,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 120080,
//   },
//   {
//     id: 6,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "SportsBike.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 18000,
//   },
//   {
//     id: 7,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 17000,
//   },
//   {
//     id: 8,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "SportsBike.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 19000,
//   },
//   {
//     id: 9,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 18000,
//   },
//   {
//     id: 10,
//     title: "Hero Glamour Xtec 125 cc",
//     image: "Electrical.png",
//     description: "1500 km included",
//     excess: "₹ 5/km + GST",
//     location: "Delhi",
//     price: 17700,
//   },
//   // Add more bikes here
// ];

// function DailyRental() {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState(null);
//   const [filteredBikes, setFilteredBikes] = useState(bikeData); // State to hold filtered data

//   // Function to handle filter logic
//   const handleFilter = (filterType) => {
//     let sortedBikes = [...bikeData];

//     switch (filterType) {
//       case "priceLowToHigh":
//         sortedBikes.sort((a, b) => a.price - b.price);
//         break;
//       case "priceHighToLow":
//         sortedBikes.sort((a, b) => b.price - a.price);
//         break;
//       default:
//         sortedBikes = bikeData; // Default to relevance (original order)
//     }

//     setFilteredBikes(sortedBikes);
//   };

//   const handleBookNow = (bike) => {
//     const data = new FormData();
//     data.append("id", bike.id);
//     data.append("title", bike.title);
//     data.append("description", bike.description);
//     data.append("price", bike.price);
//     data.append("location", bike.location);
//     data.append("image", bike.image);

//     setFormData(data);

//     console.log("Form Data Submitted:", Object.fromEntries(data.entries()));

//     navigate(`/accesories-component`);

//     if (window.innerWidth <= 768) {
//       navigate('/accesories');
//     } else {
//       navigate('/accesories-component');
//     }

//   };

//   return (
//     <div className="flex min-h-screen p-5">
//       <div className="w-full">
//         <div className="flex mb-6">
//           <div className='hidden sm:flex'>
//           <h2 className="text-lg font-semibold ">Sort by:</h2>
//           <div className="flex space-x-4 ml-4 "> {/* Hide on mobile */}
//             <button
//               className="text-gray-400 hover:text-[#FF9630]"
//               onClick={() => handleFilter("relevance")}
//             >
//               Relevance
//             </button>
//             <button
//               className="text-gray-400 hover:text-[#FF9630]"
//               onClick={() => handleFilter("priceLowToHigh")}
//             >
//               Price - Low to High
//             </button>
//             <button
//               className="text-gray-400 hover:text-[#FF9630]"
//               onClick={() => handleFilter("priceHighToLow")}
//             >
//               Price - High to Low
//             </button>
//           </div>
//           </div>
//         </div>

//         {/* Responsive Grid: 1 item per row on mobile, 3 items on larger screens */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//           {filteredBikes.map((bike) => (
//             <div
//               key={bike.id}
//               className="relative border rounded-md shadow-lg flex flex-col justify-between"
//             >
//               <div className="p-6">
//                 <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
//                   New
//                 </span>
//                 <img
//                   src={require(`../assets/${bike.image}`)}
//                   alt={bike.title}
//                   className="w-full mt-4 h-auto border rounded-md"
//                 />
//                 <div className="mt-4">
//                   <h2 className="text-lg text-center font-semibold">
//                     {bike.title}
//                   </h2>
//                   <div className="flex items-center text-gray-600 mt-4">
//                     <MdLocationOn className="text-xl mr-1 text-red-500" />
//                     <p className="text-gray-600 text-left">{bike.description}</p>
//                   </div>
//                   <p className="text-sm text-left pl-6">{bike.excess}</p>
//                 </div>
//               </div>
//               <div className="border-t px-4">
//                 <div className="bg-white p-1 border rounded flex items-center space-x-2 h-auto mb-4 mt-3">
//                   <p className="font-semibold text-sm whitespace-nowrap">
//                     Location:
//                   </p>
//                   <select className="flex-1 rounded px-2 py-1 h-full text-sm">
//                     {locations.map((location, i) => (
//                       <option key={i} value={location}>
//                         {location}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <div className="flex justify-between items-center p-3">
//                 <span className="text-gray-700 font-semibold">
//                   Pay: ₹{bike.price}/Month
//                 </span>
//                 <button
//                   className="bg-[#FF9630] text-white px-4 py-2 rounded"
//                   onClick={() => handleBookNow(bike)}
//                 >
//                   Book Now
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {formData && (
//         <div className="mt-4 p-4 border border-gray-300 rounded-md">
//           <h3 className="text-xl font-semibold">Submitted Form Data:</h3>
//           <pre>{JSON.stringify(Object.fromEntries(formData.entries()), null, 2)}</pre>
//         </div>
//       )}
//     </div>
//   );
// }

// export default DailyRental;


import React, { useState } from 'react';
import { MdLocationOn } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import SortAndFilter from '../Mobile Components/DailyRental/SortAndFilter'; // Import the new filter component

const locations = ["Bangalore", "Delhi", "Mumbai", "Chennai", "Hyderabad"];
const bikeData = [
  {
    id: 1,
    title: "Hero Glamour Xtec 125 cc",
    image: "Scooter.png",
    description: "1288 km included",
    excess: "₹ 3/km + GST",
    location: "Bangalore",
    price: 11753,
  },
  {
    id: 2,
    title: "Hero Glamour Xtec 125 cc",
    image: "Electrical.png",
    description: "1500 km included",
    excess: "₹ 5/km + GST",
    location: "Delhi",
    price: 12000,
  },
  {
    id: 3,
    title: "Hero Glamour Xtec 125 cc",
    image: "SportsBike.png",
    description: "1500 km included",
    excess: "₹ 5/km + GST",
    location: "Delhi",
    price: 100,
  },
  {
    id: 4,
    title: "Hero Glamour Xtec 125 cc",
    image: "Electrical.png",
    description: "1500 km included",
    excess: "₹ 5/km + GST",
    location: "Delhi",
    price: 1000,
  },
  {
    id: 5,
    title: "Hero Glamour Xtec 125 cc",
    image: "Electrical.png",
    description: "1500 km included",
    excess: "₹ 5/km + GST",
    location: "Delhi",
    price: 120080,
  },
  {
    id: 6,
    title: "Hero Glamour Xtec 125 cc",
    image: "SportsBike.png",
    description: "1500 km included",
    excess: "₹ 5/km + GST",
    location: "Delhi",
    price: 18000,
  },
  {
    id: 7,
    title: "Hero Glamour Xtec 125 cc",
    image: "Electrical.png",
    description: "1500 km included",
    excess: "₹ 5/km + GST",
    location: "Delhi",
    price: 17000,
  },
  {
    id: 8,
    title: "Hero Glamour Xtec 125 cc",
    image: "SportsBike.png",
    description: "1500 km included",
    excess: "₹ 5/km + GST",
    location: "Delhi",
    price: 19000,
  },
  {
    id: 9,
    title: "Hero Glamour Xtec 125 cc",
    image: "Electrical.png",
    description: "1500 km included",
    excess: "₹ 5/km + GST",
    location: "Delhi",
    price: 18000,
  },
  {
    id: 10,
    title: "Hero Glamour Xtec 125 cc",
    image: "Electrical.png",
    description: "1500 km included",
    excess: "₹ 5/km + GST",
    location: "Delhi",
    price: 17700,
  },
  // Add more bikes here
];

function DailyRental() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);
  const [filteredBikes, setFilteredBikes] = useState(bikeData);

  // Function to handle filter logic
  const handleFilter = (filterType) => {
    let sortedBikes = [...bikeData];

    switch (filterType) {
      case "priceLowToHigh":
        sortedBikes.sort((a, b) => a.price - b.price);
        break;
      case "priceHighToLow":
        sortedBikes.sort((a, b) => b.price - a.price);
        break;
      default:
        sortedBikes = bikeData; // Default to relevance (original order)
    }

    setFilteredBikes(sortedBikes);
  };

  const handleBookNow = (bike) => {
    const data = new FormData();
    data.append("id", bike.id);
    data.append("title", bike.title);
    data.append("description", bike.description);
    data.append("price", bike.price);
    data.append("location", bike.location);
    data.append("image", bike.image);

    setFormData(data);

    navigate(`/accesories-component`);

    if (window.innerWidth <= 768) {
      navigate('/accesories');
    } else {
      navigate('/accesories-component');
    }
  };

  return (
    <>
      <div className="block lg:hidden absolute bottom-4  z-50 w-full">
        <SortAndFilter handleFilter={handleFilter} />
      </div>
      <div className="flex min-h-screen p-5 z-0">
        <div className="w-full">
          {/* Show MobileFilter only on smaller screens */}
          {/* Main content area */}
          {/* <div className="overflow-y-auto h-[calc(100vh-80px)]">  */}
          <div className="overflow-y-auto h-[calc(100vh-80px)] sm:overflow-y-visible">
            <div>
              <div className="flex mb-6 hidden lg:flex">
                <h2 className="text-lg font-semibold">Sort by:</h2>
                <div className="flex space-x-4 ml-4 ">
                  <button
                    className="text-gray-400 hover:text-[#FF9630]"
                    onClick={() => handleFilter("relevance")}
                  >
                    Relevance
                  </button>
                  <button
                    className="text-gray-400 hover:text-[#FF9630]"
                    onClick={() => handleFilter("priceLowToHigh")}
                  >
                    Price - Low to High
                  </button>
                  <button
                    className="text-gray-400 hover:text-[#FF9630]"
                    onClick={() => handleFilter("priceHighToLow")}
                  >
                    Price - High to Low
                  </button>
                </div>
              </div>
            </div>


            {/* Responsive Grid: 1 item per row on mobile, 3 items on larger screens */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredBikes.map((bike) => (
                <div
                  key={bike.id}
                  className="relative border rounded-md shadow-lg flex flex-col justify-between"
                >
                  <div className="p-6">
                    <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
                      New
                    </span>
                    <img
                      src={require(`../assets/${bike.image}`)}
                      alt={bike.title}
                      className="w-full mt-4 h-auto border rounded-md"
                    />
                    <div className="mt-4">
                      <h2 className="text-lg text-center font-semibold">
                        {bike.title}
                      </h2>
                      <div className="flex items-center text-gray-600 mt-4">
                        <MdLocationOn className="text-xl mr-1 text-red-500" />
                        <p className="text-gray-600 text-left">{bike.description}</p>
                      </div>
                      <p className="text-sm text-left pl-6">{bike.excess}</p>
                    </div>
                  </div>
                  <div className="border-t px-4">
                    <div className="bg-white p-1 border rounded flex items-center space-x-2 h-auto mb-4 mt-3">
                      <p className="font-semibold text-sm whitespace-nowrap">
                        Location:
                      </p>
                      <select className="flex-1 rounded px-2 py-1 h-full text-sm">
                        {locations.map((location, i) => (
                          <option key={i} value={location}>
                            {location}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="flex justify-between items-center p-3">
                    <span className="text-gray-700 font-semibold">
                      Pay: ₹{bike.price}/Month
                    </span>
                    <button
                      className="bg-[#FF9630] text-white px-4 py-2 rounded"
                      onClick={() => handleBookNow(bike)}
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {formData && (
          <div className="mt-4 p-4 border border-gray-300 rounded-md">
            <h3 className="text-xl font-semibold">Submitted Form Data:</h3>
            <pre>{JSON.stringify(Object.fromEntries(formData.entries()), null, 2)}</pre>
          </div>
        )}
      </div>
    </>
  );
}

export default DailyRental;
